import { EventCard } from '@/sanity/fetchEvents';
import { SingleEventCard } from '../base/SingleEventCard';
import SingleEventCardMobileHorizontal from '../base/SingleEventCardMobileHorizontal';
import { useState } from 'react';
import { LoadMoreButton } from '../base/LoadMoreButton';
import styles from './EventsGrid.module.scss';

export default function EventsGrid({ events }: { events: EventCard[] }) {
  const [visibleEvents, setVisibleEvents] = useState(6);

  const showMoreEvents = () => {
    setVisibleEvents((prevVisibleEvents) => prevVisibleEvents + 6);
  };

  return (
    <div>
      {/* Desktop */}
      <div className={styles.desktopGrid}>
        {events.slice(0, visibleEvents).map((event: EventCard) => (
          <SingleEventCard event={event} key={event._id} />
        ))}
      </div>
      {/* Mobile */}
      <div className={styles.mobileList}>
        {events.slice(0, visibleEvents).map((event: EventCard) => (
          <SingleEventCardMobileHorizontal event={event} key={event._id} />
        ))}
      </div>
      {/* Load More button */}
      <div className={styles.loadMoreWrapper}>
        {visibleEvents < events.length && <LoadMoreButton onClick={showMoreEvents} />}
      </div>
    </div>
  );
}
